module.exports = __webpack_public_path__ + "static/img/4.ac2335f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/4.png
// module id = Ta6R
// module chunks = 0